module.exports = __webpack_public_path__ + "img/6d20c53.jpg";